module.exports = __webpack_public_path__ + "img/menupwbusa.8bc021d6.png";